import React, { useEffect, useState } from 'react'
import { Text, Image, View, TouchableOpacity, Dimensions } from 'react-native'
import { apiUrlWSocket } from '../../config/config'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import { ScrollView } from 'react-native'
import styles from './StoreVouchersListStyles'
import styles2 from './StoreVouchersListStyles2'
import { FlashList } from '@shopify/flash-list'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import QRCode from 'react-native-qrcode-svg'
import { getUser, openDB } from '../../db/indexDB'
import { DateFormatter } from '../customUtils/DateFormatter'
import { placeholderGeneral } from '../customUtils/Constants'
import { useWebSocket } from '../appBar/context/WebSocketContext'
import { PostsServices } from '../../../database/posts.database'
import { WEBSOCKET_TYPES } from '../../utils/Constants'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { BenefitItemModel } from '../benefits/models/BenefitItemModel'

const { width } = Dimensions.get('window')

export const StoreVouchersList = ({ vouchers, updateVoucher }: { vouchers: BenefitItemModel[]; updateVoucher: (item: BenefitItemModel) => void }) => {
    return (
        <FlashList
            data={vouchers}
            horizontal={false}
            keyExtractor={(item) => item._id}
            numColumns={1}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item: vouchers }) => <VouchersItem item={vouchers} updateVoucher={updateVoucher} />}
        />
    )
}
const VouchersItem = ({ item, updateVoucher }) => {
    const { languageFile } = getLanguage()

    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const handleClick = () => {
        if (item.status == 1) {
            return
        }
        openBottomSheet(<VouchersSheet item={item} closeBottomSheet={closeBottomSheet} updateVoucher={updateVoucher} />)
    }

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
    }

    const redeemedDate = item.redeemed_date && item.redeemed_date != '' ? new Date(item.redeemed_date).toLocaleDateString('es-AR') : null
    const redeemedBy = item.redeemed_by && item.redeemed_by != '' ? 'Canjeado: ' + item.redeemed_by : null

    const code = item.code ? item.code + ' - ' : ''
    return (
        <View>
            <TouchableOpacity onPress={() => handleClick()}>
                <View style={styles.vouchersModule}>
                    <Image
                        style={styles.voucherImage}
                        source={{
                            uri: item.cover_image ? item.cover_image : placeholderGeneral,
                        }}
                    />
                    <View style={styles.vouchersInfoContainer}>
                        {item.date_finish && (
                            <View style={[styles.flexDirectionRow, { marginBottom: 4 }]}>
                                <Text style={styles.voucherPoints}>{languageFile.validity}</Text>
                                <Text style={styles.voucherDate}>{DateFormatter({ date: item.date_finish })}</Text>
                            </View>
                        )}
                        {item.title && (
                            <Text style={styles.voucherTitle} numberOfLines={1}>
                                {code + capitalizeWords(item.title)}
                            </Text>
                        )}
                        {item.description_long && (
                            <Text style={styles.voucherDescription} numberOfLines={2}>
                                {item.description_long}
                            </Text>
                        )}
                        {item.status == 1 && redeemedBy && redeemedDate && (
                            <Text style={styles.voucherRedeemed}>{redeemedBy + ', ' + redeemedDate}</Text>
                        )}
                    </View>

                    <Feather name='chevron-right' size={22} color={theme.colors.textPrimary} />
                </View>
            </TouchableOpacity>
            <View style={styles.dividerHorizontalLine}></View>
        </View>
    )
}

export const VouchersSheet = ({
    item,
    closeBottomSheet,
    updateVoucher,
}: {
    item: BenefitItemModel
    closeBottomSheet: (l) => void
    updateVoucher: (item: BenefitItemModel) => void
}) => {
    const [showMessage, setShowMessage] = useState(false)
    const [showMessageQr, setShowMessageQr] = useState(false)
    const [message, setMessage] = useState('')
    const [description, setDescription] = useState('')
    const [showQRCode, setShowQR] = useState(true) // Se pasó a true para saltear el primer paso
    const [redeemStatus, setRedeemStatus] = useState(0)
    const webSocketInstance = useWebSocket()

    const { languageFile } = getLanguage()

    const redeemBenefit = (status: number) => {
        switch (status) {
            case -1:
                setRedeemStatus(status)
                setMessage(languageFile.voucher_canceled)
                setDescription(languageFile.you_can_try_again)
                break
            case 1:
                setRedeemStatus(status)
                setMessage(languageFile.voucher_successful)
                setDescription(languageFile.successful_promo)
                break
            case 0:
                setRedeemStatus(status)
                setMessage(languageFile.voucher_pending)
                setDescription(languageFile.wait_for_the_validation)
                break
        }

        setShowMessage(true)
    }

    const showQR = () => {
        setShowQR(true)
    }

    const closeQR = () => {}

    const DemoModel = { code: '0x0001929824B72', idPos: '507f1f77bcf86cd799439011' }

    //Pañalera tiene QR
    //Distr escanea QR
    const getQRCode = (): string => {
        var date = new Date().getDate()
        var month = new Date().getMonth() + 1
        var year = new Date().getFullYear()
        var hour = new Date().getHours()
        var minute = new Date().getMinutes()
        var finalDate = date + '/' + month + '/' + year + ' ' + hour + ':' + minute
        return JSON.stringify({ ...DemoModel, date: finalDate })
    }

    useEffect(() => {
        if (webSocketInstance) {
            // Manejar la instancia del WebSocket
            console.log('WebSocket instance is availablefsgfd', webSocketInstance)

            // Suscribirse a eventos si es necesario
            const handleMessage = async (message) => {
                console.log('Mensaje recibido:gfdsgfds', message)
                let data = JSON.parse(message)
                let user = await PostsServices.getUser()
                try {
                    if (data.type === 'benefit' && user && user['_id'] == data.user) {
                        console.log('Mensaje recibido del WebSocket:', data.user, user['_id']) //@juli aca hago lo de websocket
                        redeemBenefit(0)
                    }
                } catch (error) {
                    console.log('Error al setear los beneficios y vouchers: ', error)
                }
            }

            const handleMessageRedem = async (message) => {
                console.log('Mensaje recibido:gfdsgfds', message)
                let data = JSON.parse(message)
                let user = await PostsServices.getUser()
                try {
                    if (data.type === 'benefit_redeem' && user && user['_id'] == data.user) {
                        console.log('Mensaje recibido del WebSocket:', data.user, user['_id'])

                        // Update benefit
                        let newItem = item
                        newItem.status = 1
                        newItem.redeemed_by = data.redeemed_by
                        newItem.redeemed_date = data.redeemed_date
                        updateVoucher(newItem)
                        redeemBenefit(1)
                    }
                } catch (error) {
                    console.log('Error al setear los beneficios y vouchers: ', error)
                }
            }

            webSocketInstance.addEventListener(WEBSOCKET_TYPES.BENEFIT, handleMessage)
            webSocketInstance.addEventListener(WEBSOCKET_TYPES.BENEFIT_REDEEM, handleMessageRedem)

            // Limpieza: eliminar suscriptores cuando el componente se desmonta
            return () => {
                webSocketInstance.removeEventListener(WEBSOCKET_TYPES.BENEFIT, handleMessage)
                webSocketInstance.removeEventListener(WEBSOCKET_TYPES.BENEFIT_REDEEM, handleMessageRedem)
            }
        } else {
            console.log('WS NULL')
        }
    }, [webSocketInstance, showQRCode])

    return (
        <View style={styles2.contentContainer}>
            {showMessage ? (
                <ModalRedeemed status={redeemStatus} message={message} description={description} closeBottomSheet={closeBottomSheet} />
            ) : (
                <>
                    <View style={styles.mediaContainer}>
                        {showQRCode ? (
                            <>
                                <ScrollView>
                                    {item.code_qr && item.code_qr != '' ? (
                                        <View style={{ alignItems: 'center' }}>
                                            <View style={styles.spacer1}></View>
                                            <QRCode value={item.code_qr} size={width / 2} logoBackgroundColor='transparent' />
                                        </View>
                                    ) : (
                                        <Text>{languageFile.there_was_a_mistake}</Text>
                                    )}

                                    <View style={styles.infoContainer}>
                                        <View style={styles.spacer1}></View>
                                        <View style={styles.spacer1}></View>
                                        {item.date_finish && (
                                            <View style={styles.containerVoucherData}>
                                                <Text style={styles.voucherVigencyModal}>{languageFile.validity}</Text>
                                                <Text style={styles.voucherDateModal}>{DateFormatter({ date: item.date_finish })}</Text>
                                            </View>
                                        )}
                                        {item.title && (
                                            <View style={styles.titleQRContainer}>
                                                <View style={styles.spacer1}></View>
                                                <Text style={styles.titleQRModal}>{item.title}</Text>
                                                <View style={styles.spacer1}></View>
                                            </View>
                                        )}
                                        {item.description_long && <Text style={styles.description}>{item.description_long}</Text>}
                                        {showMessageQr && <Text style={styles.titleQRscaner}>{languageFile.your_code_is_being_scanned}</Text>}
                                    </View>
                                </ScrollView>
                            </>
                        ) : (
                            <ScrollView>
                                <View>
                                    <View style={styles.spacer1}></View>
                                    <Image
                                        style={styles.benefitAsset}
                                        source={{
                                            uri: item.cover_image ? item.cover_image : placeholderGeneral,
                                        }}
                                    />

                                    <View style={styles.infoContainer}>
                                        <View style={styles.spacer1}></View>
                                        <View style={styles.spacer1}></View>
                                        {item.date_finish && (
                                            <View style={styles.containerVoucherData}>
                                                <Text style={styles.voucherVigencyModal}>{languageFile.validity}</Text>
                                                <Text style={styles.voucherDateModal}>{DateFormatter({ date: item.date_finish })}</Text>
                                            </View>
                                        )}

                                        {item.title && (
                                            <View style={styles.titleQRContainer}>
                                                <View style={styles.spacer1}></View>
                                                <Text style={styles.titleQRModal}>{item.title}</Text>
                                                <View style={styles.spacer1}></View>
                                            </View>
                                        )}
                                        {item.description_long && <Text style={styles.description}>{item.description_long}</Text>}
                                    </View>
                                </View>
                            </ScrollView>
                        )}
                    </View>

                    {showQRCode ? (
                        <>
                            {/*<View style={styles.buttonContainer}>
                                {item.date_finish && (
                                    <View style={styles.containerVoucherData}>
                                        <Text style={styles.voucherVigencyModal}>{languageFile.validity}</Text>
                                        <Text style={styles.voucherDateModal}>{DateFormatter({ date: item.date_finish })}</Text>
                                    </View>
                                )}
                                <View style={styles.spacer1}></View>
                            </View>*/}
                            <View style={styles.spacer1}></View>
                            <View style={styles.spacer1}></View>
                            <View style={styles.spacer1}></View>
                        </>
                    ) : (
                        <>
                            <View style={styles.buttonContainer}>
                                <TouchableOpacity onPress={() => showQR()} style={styles.mainButton}>
                                    <Text style={styles.mainButtonText}>{languageFile.view_qr}</Text>
                                </TouchableOpacity>
                            </View>
                        </>
                    )}
                </>
            )}
        </View>
    )
}

const ModalRedeemed = ({
    status,
    message,
    description,
    closeBottomSheet,
}: {
    status: number
    message: string
    description: string
    closeBottomSheet: (l) => void
}) => {
    const { languageFile } = getLanguage()

    const image =
        status == 1
            ? require('../../../assets/voucherRedeemed.png')
            : status == 0
            ? require('../../../assets/voucherPending.png')
            : require('../../../assets/voucherCancelled.png')
    return (
        <View style={styles2.messageContainer}>
            <View style={styles2.messageContainer}>
                <View>
                    <Image style={styles2.benefitAsset} source={image} />
                </View>

                <Text style={styles2.messageText}>{message}</Text>

                <Text style={styles2.descriptionText}>{description}</Text>
            </View>
            <TouchableOpacity onPress={() => closeBottomSheet(true)} style={[styles2.mainButton, { marginBottom: 10 }]}>
                <Text style={styles2.mainButtonText}>{languageFile.return_to_store}</Text>
            </TouchableOpacity>
        </View>
    )
}
